import { AssetController, ControllerHelper, MediaDownloadDto } from 'collaboration-service';
import { SelectFileModuleProps } from 'components/FileSelector';
import { Button, getUriFromLinkByName, Modal, Tooltip } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';
import { useImgI18N } from 'services/ImgI18N';
import { EditorsSC as T } from './EditorsSC';

interface AssetMediaSelectorProps {
    selectProps: Omit<SelectFileModuleProps, "filesSelected">;
}

const AssetMediaSelection = (p: AssetMediaSelectorProps) => {
    const { selectProps } = p;
    const [open, setOpen] = React.useState<boolean>(false);
    const { t } = useImgI18N("general");
    const m = t("select from assets");
    const [content, setContent] = React.useState<MediaDownloadDto[]>([]);

    React.useEffect(() => {
        const load = async () => {
            const assets = await ControllerHelper.singleCall({}, AssetController.GetAssets, true);
            if (assets) {
                //                console.log('assets => ', assets);
                setContent(_.map(assets.elements, e => e.media));
            }
        }
        load();
    }, []);

    return (
        <>
            <Modal
                active={open}
                icon="copy"
                header={m}
                width="wide"
                fixed
                footer={<Button {...selectProps.buttonProps} floated='right' icon="times" content={t("cancel")} onClick={() => setOpen(false)} />}
            >
                <T.G style={{ fontWeight: "bolder", background: "rgba(0,0,0,0.05)" }}>
                    <T.D></T.D>
                    <T.L>{t("language")}</T.L>
                    <T.L>{t("content")}</T.L>
                </T.G>
                {_.map(content, (cc, i) => {
                    const cl = () => {
                        setOpen(false);
                        const toSet = { ...cc, changed: true, copyByReference: true };
                        //                        console.log('toSet => ', toSet);
                        selectProps.fileSelected(undefined, toSet);
                    }
                    return (
                        <T.G key={`${cc.fileName}-${i}`}>
                            <Button {...selectProps.buttonProps} icon="copy" onClick={cl} />
                            <T.D></T.D>
                            <T.L>
                                <a href={getUriFromLinkByName(cc, "self")} target="_blank" rel="noreferrer">
                                    {cc.fileName}
                                </a>
                            </T.L>
                        </T.G>
                    )
                })}
            </Modal>
            <Tooltip tooltipText={m} offsetX={-35} position="top" noMargin >
                <Button {...selectProps.buttonProps} icon="package" onClick={() => setOpen(true)} />
            </Tooltip>
        </>
    );
}
export default AssetMediaSelection;